import { ConditionAttribute } from 'shared/types/graphql';

export const getSendConditionLabel = (conditionAttribute: ConditionAttribute): string => {
  switch (conditionAttribute) {
    case ConditionAttribute.AppointmentTypeId:
      return 'Appointment Type';
    case ConditionAttribute.ClinicRoomId:
      return 'Appointment Room';
    case ConditionAttribute.ClinicEmployeeId:
      return 'Appointment Provider';
    case ConditionAttribute.SpeciesType:
      return 'Patient Species';
    case ConditionAttribute.PetAgeInYears:
      return 'Patient Age';
    case ConditionAttribute.CareMembershipStatus:
      return 'Care Membership Status';
    default:
      return '';
  }
};
